import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ComponentStatus, StateComponent } from '../../../../../common/components/state/state.component';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TournamentApiService } from '../../../../../common/apis/tournament/tournament-api.service';
import { NotificationService } from '../../../../../common/services/notification.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CompetitionGroupApiService } from '../../../../../common/apis/competition-group/competition-group-api.service';
import { ITournamentModel } from '../../../../../common/apis/tournament/model/tournament.model';
import { MatButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';

import { MatSelect } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { LoadingContainerComponent } from '../../../../../common/components/loading-container/loading-container.component';

@Component({
  selector: 'oo-create-tournament-dialog',
  templateUrl: './create-competition-group-dialog.component.html',
  styleUrls: ['./create-competition-group-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LoadingContainerComponent,
    MatDialogTitle,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatError,
    MatLabel,
    MatSelect,
    MatOption,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class CreateCompetitionGroupDialogComponent extends StateComponent<CreateTournamentDialogComponentState> implements OnInit {

  private readonly fb = inject(UntypedFormBuilder);
  state: CreateTournamentDialogComponentState = {
    status: 'loading',
    tournaments: [],
    form: this.fb.group({
      name: ['', [Validators.required]],
      tournamentId: [null, Validators.required],
    }),
  };
  private readonly dialogRef = inject<MatDialogRef<CreateCompetitionGroupDialogComponent>>(MatDialogRef);
  private readonly compGroupApi = inject(CompetitionGroupApiService);
  private readonly tournamentApi = inject(TournamentApiService);
  private readonly notificationService = inject(NotificationService);
  private readonly snackBar = inject(MatSnackBar);

  ngOnInit(): void {
    this.dialogRef.updateSize('300px', '300px');
    this.fetchData();
  }

  createCompGroup(): void {
    this.updateStatus('loading');
    this.compGroupApi.createCompGroup(this.state.form.value)
      .then(() => {
        this.snackBar.open('Group was created', undefined, {
          duration: 3000,
        });
        this.dialogRef.close(true);
      })
      .catch((e: Error) => {
        console.error(e);
        this.notificationService.notifyError();
      });
  }

  private fetchData(): void {
    this.updateStatus('loading');
    this.tournamentApi.getAvailableTournaments()
      .then((tournaments) => {
        this.updateStatus('ready');
        this.updateState({
          status: 'ready',
          tournaments,
        });
      })
      .catch((e: Error) => {
        console.error(e);
        this.notificationService.notifyError();
      });
  }
}

interface CreateTournamentDialogComponentState {
  status: ComponentStatus;
  form: UntypedFormGroup;
  tournaments: ITournamentModel[];
}
